<section class="py-5 bg-card home-sections">
  <div class="container container-max">
    <ul class="breadcrumbs">
      <li><a [routerLink]="''">Home</a></li>
      <li>About</li>
    </ul>
  </div>
</section>

<bor-about-section [isPage]="true" />
<!--<section class="container pb-4 mb-5">-->
<!--  <div class="card p-0">-->
<!--    <div class="card-body border-bottom">-->
<!--      <h1 class="card-title">About – Nigeria's Beneficial Ownership Register (BOR)</h1>-->
<!--    </div>-->
<!--    <div class="card-body">-->
<!--      <p class="pb-3">The Corporate Affairs Commission has built a register for Nigeria Beneficiary Ownership in accordance with international standard of Beneficiary Ownership Data Standards (BODS) under the guidance of World Bank. This portal provides search function and information on Persons with Significant Control (PSC).</p>-->

<!--      <p class="pb-3">It also provides an Enterprise Service Bus (ESB) gateway for data exchange in accordance with BODS in in JSON format.</p>-->

<!--      <p class="pb-3">This service will provide the module for data exchange between CRP and external applications/databases like Global Beneficiary Ownership Register G-BOR.</p>-->

<!--      <p class="pb-3">This document highlights the detailed information of persons with significant control currently collected by CAC-BOR applications and stored in the register database.</p>-->

<!--      <p class="pb-3">The data in the database forms the basis for data exchange. <br />-->
<!--        Any data exchange with external systems like Open Ownership will be communicated via a standard REST service, governed by standard protocol of CAC Enterprise Service Bus.</p>-->
<!--    </div>-->
<!--  </div>-->
<!--</section>-->
